import { useCallback } from 'react';

interface TabLazyLoadProps {
    networkData: any;
    matrixData: any;
    keywordPivotData: any;
    advantageData: any;
    marketOverview: any;
    opportunityData: any;
    spPeriods: any[];
    fetchNetworkData: () => void;
    fetchMarketMatrixData: () => void;
    fetchKeywordPivot: () => void;
    fetchAdvantageKeywords: (params: any) => void;
    fetchMarketOverview: (params: any) => void;
    fetchOpportunityKeywords: (params: any) => void;
}

export const useTabLazyLoad = ({
    networkData,
    matrixData,
    keywordPivotData,
    advantageData,
    marketOverview,
    opportunityData,
    spPeriods,
    fetchNetworkData,
    fetchMarketMatrixData,
    fetchKeywordPivot,
    fetchAdvantageKeywords,
    fetchMarketOverview,
    fetchOpportunityKeywords,
}: TabLazyLoadProps) => {
    const handleTabChange = useCallback((key: string) => {
        // 品牌竞争网络
        if (key === 'brand-competition' && !networkData) {
            fetchNetworkData();
        }

        // 市场矩阵相关
        if ((key === 'market-matrix' || key === 'rank-range' || key === 'brand-shift') && !matrixData) {
            fetchMarketMatrixData();
        }

        // 搜索查询绩效相关
        if (spPeriods.length > 0) {
            if (key === 'sp-pivot' && !keywordPivotData) {
                fetchKeywordPivot();
            }
            if (key === 'sp-advantage' && !advantageData) {
                fetchAdvantageKeywords({ period_ids: [spPeriods[0].id] });
            }
            if (key === 'sp-overview' && !marketOverview) {
                fetchMarketOverview({ period_ids: [spPeriods[0].id] });
            }
            if (key === 'sp-opportunity' && !opportunityData) {
                fetchOpportunityKeywords({ period_ids: [spPeriods[0].id] });
            }
        }
    }, [
        networkData,
        matrixData,
        keywordPivotData,
        advantageData,
        marketOverview,
        opportunityData,
        spPeriods,
        fetchNetworkData,
        fetchMarketMatrixData,
        fetchKeywordPivot,
        fetchAdvantageKeywords,
        fetchMarketOverview,
        fetchOpportunityKeywords,
    ]);

    return { handleTabChange };
};
